<script>
import { iBadge, iBadgeColours } from '@inscribe/signal';
const VerificationType = {
  HIGH_RISK: 'HIGH_RISK',
  INCONCLUSIVE: 'INCONCLUSIVE',
  LOW_RISK: 'LOW_RISK',
};

const BadgePropertiesEnum = {
  [VerificationType.HIGH_RISK]: {
    label: 'High Risk',
    colour: iBadgeColours.ERROR,
    icon: 'small-alert-triangle',
  },
  [VerificationType.INCONCLUSIVE]: {
    label: 'Inconclusive',
    colour: iBadgeColours.WARNING,
    icon: 'small-alert-circle',
  },
  [VerificationType.LOW_RISK]: {
    label: 'Low Risk',
    colour: iBadgeColours.SUCCESS,
    icon: 'small-check-circle',
  },
};

export default {
  name: 'document-review-agent-verification',
  components: { iBadge },
  props: {
    index: {
      type: Number,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    result: {
      type: String,
      required: true,
    },
    rationale: {
      type: String,
      required: true,
    },
    urls: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return { iBadgeColours };
  },
  computed: {
    riskBadgeProperties() {
      return BadgePropertiesEnum[this.result];
    },
    urlsWithLabels() {
      return this.urls.map((url) => {
        const hostname = new URL(url).hostname;
        const domain = hostname.replace(/^www\./, '');
        return {
          url,
          label: domain,
        };
      });
    },
  },
};
</script>

<template>
  <div
    class="verification-item d-flex flex-column align-items-start i-gap-4 i-pr-10"
  >
    <div class="i-text-subheading-3 i-text-neutral-120">
      {{ title }}
    </div>

    <i-badge
      :colour="riskBadgeProperties.colour"
      :icon="riskBadgeProperties.icon"
      :label="riskBadgeProperties.label"
      :has-leading-icon="true"
      :interactable="true"
    ></i-badge>

    <div class="i-text-body-3 i-text-neutral-120">
      {{ rationale }}
    </div>

    <ul v-if="urls.length > 0">
      <li
        v-for="({ url, label }, idx) in urlsWithLabels"
        :key="idx"
        class="i-text-body-3 i-text-neutral-120"
      >
        <a :href="url" target="_blank">
          <i-badge
            :colour="iBadgeColours.NEUTRAL"
            icon="small-arrows-expand"
            :has-leading-icon="true"
            :outline="true"
            :label="label"
            :interactable="true"
          ></i-badge>
        </a>
      </li>
    </ul>
  </div>
</template>

<style scoped lang="scss">
.verification-item {
  &:not(:first-child) {
    border-top: 1px solid $light-neutral-60;
    padding-top: map-get($increments, 9);
  }

  ul {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-items: flex-start;
    gap: map-get($increments, 4);
    width: 100%;
    padding-left: 0;
    margin-bottom: 0;

    li {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
}
</style>
